module.exports = __webpack_public_path__ + "static/media/swapBtn.bb753cca.svg";